import cn from 'clsx';
import { ButtonHTMLAttributes, FC } from 'react';

import type { IconType, ColorPalette } from '../../../types';
import Icon from '../../Icon';

import s from './IconButton.module.scss';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: IconType;
  color?: ColorPalette;
}

const IconButton: FC<React.PropsWithChildren<React.PropsWithChildren<IconButtonProps>>> = ({ icon, disabled, className, color = 'gray.800', ...props }) => {
  return (
    <button type="button" disabled={disabled} className={cn(s.button, className)} {...props}>
      <Icon type={icon} size={icon === 'bznav-refund-logo' ? 104 : 24} height={icon === 'bznav-refund-logo' ? 22 : undefined} color={color} />
    </button>
  );
};

export default IconButton;
